import React from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import {  transactionService , walletService } from '../../_services'

class WalletPage extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            
            txlist : [] , 
            txpages : 0 , 
            tx_list_loading : true , 
            assetlist : [] 
        }

        this.onFetchTxData = this.onFetchTxData.bind(this);
    }

    componentDidMount(){
        walletService.getAllAssets()
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    assetlist : response
                })
            }
        })
    }

    onFetchTxData(state , instance){
        const {  authentication } = this.props;

        state.page += 1;    //fix react table state started from one 
        
        transactionService.getMemberTransactionList(state.page , state.pageSize , authentication.user.id)
        .then(response => {
            if(response){
                //update state with list 
                this.setState({
                    txlist : response.list , 
                    txpages : response.pages , 
                    tx_list_loading : false
                })
            }
        })
    }

    render(){
        const { wallet } = this.props;
        const { txlist , txpages , tx_list_loading , assetlist  } = this.state;
        
        const txcolumns = [
            {
                Header: 'Transaction time',
                accessor: 'createdstr'
            },
            {
                Header: 'Type',
                accessor: 'type'
            },
            {
                Header: 'Debit',
                accessor: 'debit' , 
                Cell: c => (
                    c.original.debit &&
                    <span>{`${c.original.debitCurrency} ${c.original.debit}`}</span>
                )
            },
            {
                Header: 'Credit',
                accessor: 'credit', 
                Cell: c => (
                    c.original.credit && 
                    <span>{`${c.original.creditCurrency} ${c.original.credit}`}</span>
                )
            },
            {
                Header: 'Balance',
                accessor: 'balance'
            }
        ]

        return(
            <section className="section m-t-xs m-b-lg">
                <div className="container">
                    <div className="columns">
                        <div className="column is-6 has-border p-lg">
                            <h4>My Wallet</h4>
                            {
                                wallet.userwallet ? (
                                    wallet.userwallet.length > 0 && 
                                    <table className="m-t-lg table is-bordered is-striped is-fullwidth">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            assetlist.map((asset) =>{
                                                return(
                                                    <tr>
                                                        <td>{asset.id}</td>
                                                        <td>
                                                            {
                                                                wallet.userwallet.map((item) => {
                                                                    if(item.currency === asset.id){
                                                                        return <div>{item.balance}</div>
                                                                    }
                                                                })
                                                            }
                                                        </td>
                                                    </tr>
                                                
                                                )
                                            })   
                                            /*
                                            wallet.userwallet.map((item) => {
                                                return(
                                                    <tr>
                                                        <td>{item.currency}</td>
                                                        <td>{item.balance}</td>
                                                    </tr>
                                                
                                                )
                                            })*/
                                        }
                                        </tbody>
                                    
                                    </table>
                                )
                                : (
                                    <p className="">
                                        Current wallet is empty . Please <a href="/account/deposit">deposit here</a> 
                                    </p>
                                )
                            }
                        </div>
                        <div className="column is-6">
                            
                            <h4>Member Transactions</h4>
                            <div className=" m-t-md">
                                <ReactTable
                                    manual
                                    data={txlist}
                                    pages={txpages}
                                    loading={tx_list_loading}
                                    columns={txcolumns}
                                    defaultPageSize = {10} 
                                    onFetchData = {this.onFetchTxData}
                                    className="-striped -highlight"
                                    NoDataComponent = { ()=> { return []} }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    const { wallet , authentication } = state;
    return {
       wallet , authentication
    };
}

const connected = connect(mapStateToProps)(WalletPage);
export { connected as WalletPage }; 



// WEBPACK FOOTER //
// ./src/Views/WalletPage/WalletPage.jsx